const article = {
  id: 2,
  category: "Droit de l'UE",
  title: "Google condamné à 2,95 milliards d’euros : Que risque votre secteur ?",
  text: "Analyse des amendes record de l’UE contre les géants du numérique et des risques pour les entreprises françaises. Nos experts vous éclairent.",
  link: "/articles/amendes-ue-google-pratiques-anticoncurrentielles-2025",
  date: "Septembre 2025",
  highlight: "Un signal fort pour la concurrence loyale en Europe"
};

export default article;
